import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import { useSeo } from "@/hooks/useSeo";
import { faqs } from "@/mocks/faqs";
import Hero from "./components/Hero";
import ProgressStats from "./components/ProgressStats";
import LatestStory from "./components/LatestStory";
import StoryArcs from "./components/StoryArcs";
import HotContent from "./components/HotContent";
import ChapterPreview from "./components/ChapterPreview";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import Newsletter from "./components/Newsletter";

export default function Home() {
  useSeo({
    title: "斗罗大陆漫画追更进度速览 · 最新剧情与话数更新",
    description:
      "斗罗大陆漫画最新剧情、更新到哪了、第几话、完结没有？这里汇总斗罗大陆漫画追更进度、剧情主线与完结情况，追更前先看进度，不迷路。",
    keywords:
      "斗罗大陆 漫画,斗罗大陆漫画最新剧情,斗罗大陆漫画更新到哪了,斗罗大陆漫画第几话,斗罗大陆漫画完结没有",
    canonicalPath: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "斗罗漫报 · 斗罗大陆漫画追更信息站",
        url: "https://dcomx.github.io/",
        description: "斗罗大陆漫画追更进度、最新剧情、话数整理与完结情况速览。",
      },
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "斗罗大陆漫画追更进度速览",
        url: "https://dcomx.github.io/",
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <ProgressStats />
        <LatestStory />
        <StoryArcs />
        <HotContent />
        <ChapterPreview />
        <Testimonials />
        <Faq />
        <Newsletter />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}